// extracted by mini-css-extract-plugin
export default {"imageContainer":"MyProfilePhotos_imageContainer__TIn3p","image":"MyProfilePhotos_image__i4-hx"};